import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getIndiceValorKpis(): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/indice_valor/', {});
  return data;
}

type QueryFnType = typeof getIndiceValorKpis;

function useIndiceValorKpis() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-indice-valor-kpis'],
    queryFn: getIndiceValorKpis,
  });
}

export { getIndiceValorKpis, useIndiceValorKpis };
